/* ------------------------------------------------------------------
 * 募集要約セクションの初期化
 * - ツールチップ表示/非表示
 * - 要約の表示/非表示トグル
 * - 詳細情報へのリンク展開
 * ------------------------------------------------------------------ */

// NOTE: ハイライトアニメーション用スタイルを動的に注入
(function injectHighlightStyle() {
  if (document.getElementById("jsSummarySourceHighlightStyle")) return;

  const style = document.createElement("style");
  style.id = "jsSummarySourceHighlightStyle";
  style.textContent = `
    .jsSummarySourceHighlighted {
      animation: jsSummarySourceHighlight 2s ease-out;
    }
    @keyframes jsSummarySourceHighlight {
      0% { background-color: rgba(255, 235, 59, 0.6); }
      100% { background-color: transparent; }
    }
  `;
  document.head.appendChild(style);
})();

function initializeGeneratedArticleSummary() {
  const container = document.querySelector(".jsGeneratedArticleSummary");
  if (!container) return;

  // ドキュメントクリックでツールチップを閉じる
  document.addEventListener("click", () => {
    container
      .querySelectorAll(".jsSummaryTooltipContent")
      .forEach((el) => el.remove());
  });

  // ツールチップ表示
  container.addEventListener("click", (e) => {
    const icon = e.target.closest(".jsSummaryTooltip");
    if (!icon) return;

    e.stopImmediatePropagation();
    e.preventDefault();

    const existingTooltip = icon.querySelector(".jsSummaryTooltipContent");
    if (existingTooltip) {
      existingTooltip.remove();
      return;
    }

    container
      .querySelectorAll(".jsSummaryTooltipContent")
      .forEach((el) => el.remove());

    const { text } = icon.dataset;
    const tooltip = document.createElement("div");
    tooltip.className = "p_tooltip jsSummaryTooltipContent";
    tooltip.textContent = text;
    icon.appendChild(tooltip);

    const summaryItem = icon.closest(".jsSummaryItem");
    const iconRect = icon.getBoundingClientRect();
    const summaryItemRect = summaryItem.getBoundingClientRect();
    const tooltipWidth = tooltip.offsetWidth;

    const targetTooltipGlobalLeft =
      summaryItemRect.left + summaryItemRect.width / 2 - tooltipWidth / 2;
    const cssLeftForTooltip = targetTooltipGlobalLeft - iconRect.left;

    tooltip.style.left = `${cssLeftForTooltip}px`;
  });

  // 表示/非表示トグル
  container.addEventListener("click", (e) => {
    const btn = e.target.closest(".jsSummaryHideToggleBtn");
    if (!btn) return;

    e.preventDefault();
    const summary = btn.closest(".jsGeneratedArticleSummary");
    const { action } = btn.dataset;

    if (action === "hide") {
      summary.classList.add("isHidden");
      btn.innerHTML = '表示する<i class="fa fa-angle-down"></i>';
      btn.dataset.action = "show";
      btn.classList.remove("gtmClickGeneratedArticleSummaryHide");
    } else {
      summary.classList.remove("isHidden");
      btn.innerHTML = '非表示にする<i class="fa fa-angle-up"></i>';
      btn.dataset.action = "hide";
      btn.classList.add("gtmClickGeneratedArticleSummaryHide");
    }
  });

  // 詳細情報へのリンク展開
  container.addEventListener("click", (e) => {
    const link = e.target.closest(".jsExpandDetailInfo");
    if (!link) return;

    e.preventDefault();

    const targetUrl = link.dataset.href || link.getAttribute("href");
    const detailSection = document.getElementById("jsReadmoreDetail");

    if (detailSection && typeof jQuery !== "undefined") {
      // NOTE: readmoreプラグインはjQueryに依存しているため、ここだけjQueryを使用
      jQuery(detailSection).readmore("destroy");
      setTimeout(() => {
        window.location.href = targetUrl;
      }, 0);
    } else {
      window.location.href = targetUrl;
    }
  });

  // NOTE: source_columnへのスクロール処理（source_textがない場合のフォールバック）
  container.addEventListener("click", (e) => {
    const link = e.target.closest(
      ".jsSummaryDetailLink, .jsSummaryTitleContainer a"
    );
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href || !href.startsWith("#jsSummarySource")) return;

    e.preventDefault();

    const className = href.substring(1);
    const target = document.querySelector(`.${className}`);

    if (target) {
      const windowHeight = window.innerHeight;
      const targetRect = target.getBoundingClientRect();
      const targetOffset = targetRect.top + window.scrollY;
      const scrollTo = targetOffset - windowHeight * 0.3;

      window.scrollTo({
        top: scrollTo,
        behavior: "smooth",
      });

      target.classList.add("jsSummarySourceHighlighted");
      setTimeout(
        () => target.classList.remove("jsSummarySourceHighlighted"),
        2000
      );
    }
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeGeneratedArticleSummary;